// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1zgy9","large":"styles_large__1FCa6"};